/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, s: NonNullable<unknown> }} Time_Resend_CodeInputs */



/**
* | timeResendCodePlural | output |
* | --- | --- |
* | "one" | "You can resend a code in {s} second" |
* | "other" | "You can resend a code in {s} seconds" |
*
* @param {Time_Resend_CodeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const time_resend_code = /** @type {((inputs: Time_Resend_CodeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Resend_CodeInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const timeResendCodePlural = registry.plural("en", i?.count, {}, true);
		if (timeResendCodePlural === "one") return /** @type {LocalizedString} */ (`You can resend a code in ${i?.s} second`);
		if (timeResendCodePlural === "other") return /** @type {LocalizedString} */ (`You can resend a code in ${i?.s} seconds`);
		return /** @type {LocalizedString} */ ("time_resend_code");
	}
	{
		const timeResendCodePlural = registry.plural("fr", i?.count, {}, true);
		if (timeResendCodePlural === "one") return /** @type {LocalizedString} */ (`Vous pourrez renvoyer un code dans ${i?.s} seconde`);
		if (timeResendCodePlural === "other") return /** @type {LocalizedString} */ (`Vous pourrez renvoyer un code dans ${i?.s} secondes`);
		return /** @type {LocalizedString} */ ("time_resend_code");
	}
});